var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "primary-button",
      class: { disabled: _vm.disabled, inverse: _vm.isInverse },
      attrs: { tabindex: "-1", role: "button" },
      on: {
        mousedown: function ($event) {
          return _vm.mouseDownCallback($event)
        },
        click: function ($event) {
          return _vm.callback($event)
        },
      },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading-wrapper" }, [
            _c("div", { staticClass: "loading-spinner" }),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }